// Known schools offered in the student forms.
// The field stays free-text: anything not on this list can simply be typed in.
export const SCHOOL_NAMES = [
  'ACS International Singapore',
  'ADNI Islamic School',
  'Adcote School United Kingdom',
  'Amnuay Silpa School',
  'Anglo Singapore International School',
  'Ascot International School',
  'Assumption College Primary Section',
  'Assumption Convent Lam Narai School',
  'Attawit School',
  'Bangkok Christian College',
  'Bangkok International Preparatory and Secondary School Bangkok Prep',
  'Bangkok Patana School',
  'BASIS International School Bangkok',
  'Berda Claude International School Phuket',
  'Berkeley International School',
  'Bright Start Academy',
  'Brighton College Bangkok',
  'British Columbia International School Bangkok',
  'British International School Phuket',
  'Bromsgrove International School Thailand',
  'Cambridge Home School Online',
  'Canadian International School of Thailand',
  'Cardiff Sixth Form College',
  'Cheltenham Ladies’ College',
  'Chiang Mai International School',
  'Chiang Mai University Demonstration School',
  'Chokchai School',
  'Choate Rosemary Hall',
  'Chonprathanwittaya School',
  'Chulalongkorn University',
  'Chulalongkorn University Demonstration Secondary School',
  'Clifton College',
  'Concordian International School',
  'Daruna Ratchaburi School',
  'DBS Denla British School',
  'Debsirin School',
  'Demonstration School of Khon Kaen University',
  'DLTS International School',
  'D-PREP International School',
  'Dulwich College Bangkok',
  'ELC International School Bangkok',
  'Epsom Girls Grammar School New Zealand',
  'Eton College',
  'Fairfax Christian School',
  'Garden International School Bangkok',
  'Glenalmond Phuket International School',
  'Harrow International School Bangkok',
  'HeadStart International School Phuket',
  'Heathfield International School',
  'Heya Homeschool',
  'Highgate International School Thailand',
  'International Christian School Nonthaburi',
  'International Community School Bangkok',
  'International School Bangkok',
  'Iqra Samansuksa School',
  'Kasetsart University Laboratory School Center for Educational Research and Development',
  'King Mongkut’s Institute of Technology Ladkrabang International Demonstration School',
  'King’s College International School Bangkok',
  'King’s College London',
  'KIS International School',
  'Knightsbridge House International School',
  'Lanna International School Thailand',
  'Learn Satit Pattana School',
  'Lycée Français International de Bangkok',
  'Mahidol University International Demonstration School',
  'Mater Dei School',
  'Meitoku Gijuku Senior High School Japan',
  'Middleton International School Bangkok',
  'Mill Hill International School Thailand',
  'Mooltripakdee International School',
  'NIST International School',
  'Norwich International School Bangkok',
  'Panyaden International School',
  'Panyapiwat Institute of Management',
  'Panyapiwat Institute of Management Demonstration School',
  'Patanadek School Khon Kaen',
  'Patumwan Demonstration School Srinakharinwirot University',
  'Plearnpattana School',
  'Prem Tinsulanonda International School',
  'Princess Chulabhorn Science High School',
  'Raffles American School',
  'Rambhai Barni Rajabhat University Demonstration School',
  'Ramkhamhaeng University Demonstration School',
  'Rangsit University Demonstration School',
  'Ratwinit Bangkaeo School',
  'Regent’s International School Bangkok',
  'Regents International School Pattaya',
  'Roong Aroon School',
  'Ruamrudee International School',
  'Rugby School Thailand',
  'Sahavith School Suphan Buri',
  'Saint Francis Xavier Convent School',
  'Saint Gabriel’s College',
  'Saint Joseph Convent School',
  'Saipanyarangsit School',
  'Samsenwittayalai School',
  'Sangsom School',
  'Sarasas Ektra School',
  'Shrewsbury International School Bangkok',
  'Singapore International School',
  'SPGS International School Bangkok',
  'St Andrews International School',
  'St Joseph School',
  'St Peter’s School Cambridge New Zealand',
  'St Stephen’s International School',
  'Srinakharinwirot University Prasarnmit Demonstration School',
  'Suankularb Wittayalai School',
  'Summer Fields School',
  'Swiss School Bangkok',
  'Teeratada School',
  'Thai-Chinese International School',
  'Thai Christian School',
  'The American School of Bangkok',
  'The Essence School',
  'The Illawarra Grammar School Australia',
  'The Jataka School',
  'The Newton Sixth Form',
  'The Worthgate School',
  'Thammasat University',
  'Traill International School',
  'Triam Udom Suksa School',
  'Trinity International School',
  'United World College Thailand',
  'VERSO International School',
  'Wattana Wittaya Academy',
  'WeLearn Academy',
  'Wellington College International School Bangkok',
  'Wells International School',
  'Wycombe Abbey International School Bangkok',
  'XCL American School of Bangkok',
];

export const SCHOOL_OPTIONS = SCHOOL_NAMES.map((name) => ({ value: name, label: name }));

export default SCHOOL_NAMES;
